import Button from "@components/ui/button";
import { useAppDispatch } from "@store";
import { closeDialog } from "@store/dialogs";
import { useCallback } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import "../styles/mobile-message-dialog.scss";

export const MobileMessageDialogContent = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleGoToAnalytics = useCallback(() => {
    navigate("/pages/analytics");
    dispatch(closeDialog("mobile-message-dialog"));
  }, [navigate, dispatch]);

  return createPortal(
    <div
      id="mobile-message-dialog"
      className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-lg tw-bg-blue-50 tw-p-0"
    >
      <div className="tw-relative">
        <img
          className="tw-block tw-h-auto tw-w-[239px] tw-animate-[fadeIn_0.2s_ease-out_0.8s_forwards] tw-opacity-0"
          src="/assets/images/small-screen-dialog/icon.svg"
          alt="Small screen icon"
          width="194"
          height="182"
        />
        <img
          className="tw-absolute tw--right-10 tw-top-[1px] tw-block tw-h-[95px] tw-w-[95px] tw-scale-[1.2] tw-animate-[checkAnimation_0.3s_ease-out_1s_forwards] tw-opacity-0"
          src="/assets/images/small-screen-dialog/check.svg"
          alt="Small screen icon"
          width="95"
          height="95"
        />
      </div>

      <h2 className="min-[440px]:[&_br]:tw-hidden tw-m-0 tw-mt-[25px] tw-animate-[fadeIn_0.2s_ease-out_1s_forwards] tw-p-0 tw-text-center tw-font-sans tw-text-2xl tw-font-bold tw-leading-normal tw-text-[#12033E] tw-opacity-0">
        Waiting for you at your{" "}
        <span className="tw-text-[#610CFF]">desktop</span>
      </h2>

      <p className="max-[616px]:tw-max-w-none tw-m-0 tw-mt-6 tw-max-w-[353px] tw-animate-[fadeIn_0.2s_ease-out_1.2s_forwards] tw-p-0 tw-text-center tw-font-sans tw-text-[13px] tw-font-normal tw-leading-[18px] tw-text-[#413565] tw-opacity-0">
        Please log in from your desktop, or resize your browser if you're
        already using one.
      </p>

      <p className="max-[616px]:tw-max-w-none tw-m-0 tw-mt-4 tw-max-w-[353px] tw-animate-[fadeIn_0.2s_ease-out_1.4s_forwards] tw-p-0 tw-text-center tw-font-sans tw-text-[13px] tw-font-normal tw-leading-[18px] tw-text-[#413565] tw-opacity-0">
        In the meantime, you can access your analytics
      </p>

      <Button
        className="tw-mt-10 tw-animate-[fadeIn_0.2s_ease-out_1.6s_forwards] tw-opacity-0"
        onClick={handleGoToAnalytics}
      >
        <Button.Icon
          icon="ri-bar-chart-box-line"
          className="tw-mr-1.5 tw-text-white"
        />
        Go to Analytics
      </Button>
    </div>,
    document.body,
  );
};
